import { BACKGROUNDS_SORT_DEFAULT } from '@/lib/backgrounds/sort-backgrounds'
import type { BackgroundsPanelSettings } from './types/backgrounds-panel-settings'
import type { SpreadBackgroundsPanelSettings } from './types/spread-backgrounds-panel-settings'

export const DEFAULT_BACKGROUNDS_PANEL_SETTINGS: BackgroundsPanelSettings = {
  type: 'All backgrounds',
  keywordIds: [],
  filenameQuery: '',
  size: 'any',
  placed: 'any',
  showFilename: false,
  sort: BACKGROUNDS_SORT_DEFAULT,
  filtersOpen: false,
}

/**
 * The settings to show for `spreadId`: the remembered ones if they were made on this same spread,
 * otherwise the defaults. Closing and reopening the panel on one spread keeps everything; moving
 * to another spread starts fresh. (A page refresh starts fresh too, since nothing is persisted.)
 */
export function resolveBackgroundsPanelSettings(
  stored: SpreadBackgroundsPanelSettings | null,
  spreadId: string | null
): BackgroundsPanelSettings {
  return stored && stored.spreadId === spreadId
    ? stored.settings
    : DEFAULT_BACKGROUNDS_PANEL_SETTINGS
}
